import LoginContainer from '../../../containers/auth/login';

function Login(props) {
  return <LoginContainer props={props} />;
}

export default Login;
